import { Component, Input, OnChanges } from '@angular/core'
import { FolderOverviewActions, FolderOverviewSelectors } from '../store'
import { FolderOverviewNavigationService, FolderOverviewService, FolderOverviewTab } from '../store/services'
import { FolderStatus, FolderVersion, folderStatusColor } from '@app/core/model/folder-version.model'
import { Observable, filter } from 'rxjs'

import { ActivatedRoute } from '@angular/router'
import { AuthService } from '@app/core/service/auth.service'
import { Privilege } from '@app/core/model/enums/privilege.enum'
import { SowRetainedHoursStats } from '@app/features/scope-overview/model/sow-retained-hours-stats.model'
import { Store } from '@ngrx/store'
import { Title } from '@angular/platform-browser'
import { untilDestroyed } from '@app/shared/utils/utils'

@Component({
  selector: 'folder-overview',
  templateUrl: './folder-overview.component.html',
  styleUrls: ['./folder-overview.component.scss'],
})
export class FolderOverviewComponent implements OnChanges {
  @Input() id!: number

  folder$: Observable<FolderVersion> = this.store$.select(FolderOverviewSelectors.selectFolder)
  retainedHoursStats$: Observable<SowRetainedHoursStats> = this.store$.select(
    FolderOverviewSelectors.selectRetainedHoursStats
  )
  isLoading$: Observable<boolean> = this.store$.select(FolderOverviewSelectors.selectIsLoading)

  isDetailsExpanded: boolean
  isEditDescription: boolean
  versionNumbers: number[] = []
  selectedVersion: number

  get hasEditPrivilege() {
    return this.authService.loggedInUser?.hasPrivilege(Privilege.SOW__EDIT)
  }

  constructor(
    private store$: Store,
    private titleService: Title,
    private authService: AuthService,
    private route: ActivatedRoute,
    private folderOverviewService: FolderOverviewService,
    private navigationService: FolderOverviewNavigationService
  ) {
    this.destroy$ = untilDestroyed()
    this.titleService.setTitle('Folder Overview')
  }

  ngOnChanges() {
    this.folderOverviewService.folderId = this.id
    this.store$.dispatch(FolderOverviewActions.getCurrentFolder())
    this.store$.dispatch(FolderOverviewActions.getRetainedHoursStats())

    this.folder$
      .pipe(
        this.destroy$(),
        filter((folder) => !!folder)
      )
      .subscribe((folder: FolderVersion) => {
        this.generateVersionNumbers(folder)
        this.selectedVersion = folder?.versionNumber
      })
  }

  selectTab(tab: string) {
    this.navigationService.setTab(tab as FolderOverviewTab)
  }

  updateFolder(changes: any) {
    this.store$.dispatch(FolderOverviewActions.updateFolder({ changes }))
  }

  changeVersion(versionNumber: number) {
    if (this.selectedVersion !== versionNumber) {
      this.selectedVersion = versionNumber
      this.store$.dispatch(FolderOverviewActions.changeFolderVersion({ id: this.id, versionNumber }))
    }
  }

  generateVersionNumbers(folder: FolderVersion) {
    this.versionNumbers = Array.from({ length: folder.versionNumber }, (_, i) => i + 1)
  }

  getStatusClass(status: FolderStatus): string {
    return status ? folderStatusColor[status] : ''
  }

  getActiveRouteTab = () => this.route.snapshot.queryParamMap.get('tab')
  isActiveTab = (tab?: FolderOverviewTab) => this.getActiveRouteTab() === tab

  versionDisplayFn = (version: number) => version.toString()

  private readonly destroy$
  protected readonly Privilege = Privilege
  protected readonly FolderOverviewTab = FolderOverviewTab
}
